// Same Firebase web app as mobile/firebase.config.js (logiword.com)
export const firebaseConfig = {
  apiKey: 'AIzaSyAmlpZT4VsOMKxH7DUvaylzbDwzJSyLb4o',
  authDomain: 'logiword-cb2aa.firebaseapp.com',
  projectId: 'logiword-cb2aa',
  storageBucket: 'logiword-cb2aa.firebasestorage.app',
  messagingSenderId: '667099935763',
  appId: '1:667099935763:web:298099ceedf2e4ac503be6',
  measurementId: 'G-RQQM0R1NFQ',
};
